/* Cooperative startup for the three watch viewers. Geometry, textures and shading stay unchanged. */
(() => {
  async function yieldToBrowser() {
    if (globalThis.scheduler?.yield) await globalThis.scheduler.yield();
    else await new Promise(resolve => setTimeout(resolve, 0));
  }
  async function walk(root, visit, initial, Vector) {
    let result = initial;
    const point = new Vector(), meshes = [];
    root.updateWorldMatrix(true, true);
    root.traverseVisible(mesh => { if (mesh.geometry?.attributes.position) meshes.push(mesh); });
    let deadline = performance.now() + 8;
    for (const mesh of meshes) {
      const positions = mesh.geometry.attributes.position;
      for (let index = 0; index < positions.count; index++) {
        if (mesh.isMesh) mesh.getVertexPosition(index, point);
        else point.fromBufferAttribute(positions, index);
        if (!mesh.isSkinnedMesh) point.applyMatrix4(mesh.matrixWorld);
        result = visit(result, point);
        if ((index & 1023) === 1023 && performance.now() >= deadline) {
          await yieldToBrowser();
          deadline = performance.now() + 8;
        }
      }
    }
    return result;
  }
  async function prepare(renderer, scene, viewport) {
    const model = scene.models[0], meshes = [];
    const current = () => scene.element.isConnected && scene.models[0] === model;
    for (const root of scene.models) root.traverseVisible(mesh => { if (mesh.isMesh) meshes.push(mesh); });
    const visibility = meshes.map(mesh => mesh.visible);
    try {
      await renderer.compileAsync(scene, scene.camera);
      if (!current()) return false;
      for (const mesh of meshes) mesh.visible = false;
      let deadline = performance.now() + 8;
      for (const mesh of meshes) {
        if (!current()) return false;
        // Each draw uploads the original geometry/textures, behind the unchanged poster.
        renderer.setRenderTarget(null);
        renderer.setViewport(viewport.x, viewport.y, viewport.width, viewport.height);
        mesh.visible = true;
        renderer.render(scene, scene.camera);
        mesh.visible = false;
        if (performance.now() >= deadline) {
          await yieldToBrowser();
          deadline = performance.now() + 8;
        }
      }
      return current();
    } finally {
      meshes.forEach((mesh, index) => { mesh.visible = visibility[index]; });
    }
  }
  globalThis.OmbreWatchPerformance = Object.freeze({walk, prepare});
})();
